import ApiAdmin from "@/services/apiAdmin.service";
import {
  FETCH_ALL,
  SAVE,
  ADD_NOTIFICATION,
} from "@/store/actions/actions.type";
import {
  FETCH_ALL_START,
  SET_ALL,
  FETCH_ALL_END,
  SAVE_START,
  SAVE_END,
  SET,
  SET_NOTIFICATION,
} from "@/store/mutations/mutations.type";

const state = {
  notifications: [],
  isFetchingNotifications: false,
  isFetchingNotification: false,
  isSavingNotification: false
};

const getters = {
  notifications(state) {
    return state.notifications;
  },
  isFetchingNotifications(state) {
    return state.isFetchingNotifications;
  },
  isFetchingNotification(state) {
    return state.isFetchingNotification;
  },
  isSavingNotification(state) {
    return state.isSavingNotification;
  }
};

const actions = {
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);

      ApiAdmin.query("notifications/list", params)
        .then(response => {
          context.commit(SET_ALL, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  },
  [SAVE](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SAVE_START);
      ApiAdmin.post("notifications/update", params)
        .then(response => {
          context.commit(SET, response.data);
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e.response);
        })
        .finally(() => {
          context.commit(SAVE_END);
        });
    });
  },
  [ADD_NOTIFICATION](context, params) {
    return new Promise((resolve, reject) => {
      try {
        context.commit(SET_NOTIFICATION, params.message);
        resolve();
      } catch (error) {
        console.log(error);
        reject();
      }
    });
  }
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingNotifications = true;
  },
  [SET_ALL](state, notifications) {
    state.notifications = notifications;
  },
  [SET_NOTIFICATION](state, notification) {
    if (!state.notifications.some(item => item.nome == notification.nome)) {
      state.notifications.push(notification);
    }
  },
  [FETCH_ALL_END](state) {
    state.isFetchingNotifications = false;
  },
  [SET](state, notification) {
    state.notifications = notification;
  },
  [SAVE_START](state) {
    state.isSavingNotification = true;
  },
  [SAVE_END](state) {
    state.isSavingNotification = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
